import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { QuestionBase } from "../../dynamic-form/question-base";
import { ViewAs } from "../view-as";

export interface ViewAsData {
  questions: QuestionBase<string | number | boolean>[];
}

@Component({
  selector: "app-view-as-modal",
  templateUrl: "./view-as-modal.component.html",
  styleUrls: ["./view-as-modal.component.css"],
})
export class ViewAsModalComponent implements OnInit {
  @Output() submit: EventEmitter<any> = new EventEmitter();
  @Output() back: EventEmitter<void> = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public data: ViewAsData) {}

  ngOnInit(): void {
    // do something
  }

  onSubmit(data: ViewAs): void {
    this.submit.emit(data);
  }

  goBack() {
    this.back.emit();
  }
}
